'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../../util');

var _util2 = _interopRequireDefault(_util);

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _DatePicker = require('./DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _checkbox = require('../../checkbox');

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var basicPrefixCls = 'range-picker';
var getCls = function getCls(prefix, basic, suffix) {
  return [prefix + '-' + basic, basic].map(function (item) {
    return '' + item + suffix;
  }).join(' ');
};

/**
 * 日期范围选择器
 * props.value
 * props.placeholder = ['', '']
 * //显示的时间格式，基于strftime，分隔符不限，'%Y-%m'|'%Y-%m-%d'
 * props.format = '%Y-%m-%d'
 * props.required = false //是否必须
 * props.disabled = false //是否不可用
 * props.showUpToNow = false //是否显示【至今】
 * props.onChange
 * props.prefixCls = 'mt' //类前缀
 * props.getPopupContainer = () => document.body //弹出框的父级
 * props.validation = ['', ''] //必填校验时的提示
 * props.validator = (value) => { return '123'|others } //其他校验，如果返回false或者有文本值的字符串，则校验不通过，该字符串为提示文本
 * props.disabledTime = ([startTs, endTs, isUpToNow], 'start'|'end') => { return true|false }
 * props.mode = 'default' // 'default'|'view' 默认模式|查看模式
 * props.emptyLabel = '' //查看模式下值空时的显示
 *
 */
var RangePicker = (_temp = _class = function (_Component) {
  _inherits(RangePicker, _Component);

  function RangePicker(props) {
    _classCallCheck(this, RangePicker);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RangePicker).call(this, props));

    _this.state = {
      value: _this._formatValue(props.value) || _this._getDefaultValue(props),
      valid: true
    };
    return _this;
  }

  _createClass(RangePicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_lodashCompat2.default.isEmpty(this.props.defaultValue) && _lodashCompat2.default.isEmpty(this.state.value)) {
        var value = this._formatValue(this.props.defaultValue) || this._getDefaultValue(this.props);
        this.setState({ value: value });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = this.state.value;

      if (nextProps.hasOwnProperty('value') && nextProps.value !== undefined) {
        value = this._formatValue(nextProps.value) || this._getDefaultValue(nextProps);
      }
      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var size = _props.size;
      var disabled = _props.disabled;
      var required = _props.required;
      var format = _props.format;
      var placeholder = _props.placeholder;
      var showUpToNow = _props.showUpToNow;
      var className = _props.className;
      var validation = _props.validation;
      var mode = _props.mode;
      var emptyLabel = _props.emptyLabel;
      var getPopupContainer = _props.getPopupContainer;
      var clearIcon = _props.clearIcon;
      var _state = this.state;
      var valid = _state.valid;
      var value = _state.value;
      var explain = _state.explain;


      if (mode == 'view') {
        var _result = '';
        if (value[0]) {
          _result += (0, _strftime2.default)(format, new Date(value[0]));
        }
        if (value[1]) {
          _result += ' - ' + (0, _strftime2.default)(format, new Date(value[1]));
        } else if (value[2]) {
          _result += ' - ' + '至今';
        }
        return _react2.default.createElement(
          'div',
          { className: _util2.default.classNames(className, getCls(prefixCls, basicPrefixCls, ''), basicPrefixCls + '-view', size === "small" && basicPrefixCls + '-sm') },
          !_result ? emptyLabel : _result
        );
      } else {
        var _M$classNames;

        //className
        var containerCls = getCls(prefixCls, basicPrefixCls, '');
        var datePartCls = getCls(prefixCls, basicPrefixCls, '-date-part');
        var pickerWrapperCls = getCls(prefixCls, basicPrefixCls, '-date-picker-wrapper');
        var delimiterCls = getCls(prefixCls, basicPrefixCls, '-delimiter');
        var upToNowCls = getCls(prefixCls, basicPrefixCls, '-up-to-now-part');
        var explainCls = getCls(prefixCls, basicPrefixCls, '-explain');

        var sPlaceholder = placeholder[0] || '';
        var ePlaceholder = placeholder[1] || '';

        var sValidation = void 0,
            eValidation = void 0;

        if ((0, _lodashCompat.isString)(validation)) {
          sValidation = eValidation = validation;
        } else {
          sValidation = validation[0] || '';
          eValidation = validation[1] || '';
        }

        var sValue = value[0] || undefined;
        var eValue = value[1] || undefined;

        return _react2.default.createElement(
          'div',
          { ref: 'container', className: _util2.default.classNames(className, containerCls, (_M$classNames = {}, _defineProperty(_M$classNames, basicPrefixCls + '-disabled', disabled), _defineProperty(_M$classNames, basicPrefixCls + '-required', required), _defineProperty(_M$classNames, basicPrefixCls + '-sm', size === "small"), _defineProperty(_M$classNames, basicPrefixCls + '-invalid', !valid && explain), _defineProperty(_M$classNames, 'has-error', !valid && explain), _defineProperty(_M$classNames, prefixCls + '-' + basicPrefixCls + '-up-to-now ' + basicPrefixCls + '-up-to-now', showUpToNow), _defineProperty(_M$classNames, basicPrefixCls + '-up-to-now--on', showUpToNow && value[2]), _M$classNames)) },
          _react2.default.createElement(
            'div',
            { className: datePartCls },
            _react2.default.createElement(
              'div',
              { className: pickerWrapperCls + ' start-date-picker-wrapper' },
              _react2.default.createElement(_DatePicker2.default, { ref: 'sDate', format: format,
                size: size,
                mode: mode, emptyLabel: emptyLabel,
                clearIcon: clearIcon,
                value: sValue,
                required: required,
                validation: sValidation,
                disabled: disabled,
                placeholder: sPlaceholder,
                getPopupContainer: getPopupContainer,
                onChange: this._selectStartDate.bind(this),
                disabledDate: format.indexOf('%d') == -1 ? this._disabledStartMonth.bind(this) : this._disabledStartDate.bind(this) })
            ),
            _react2.default.createElement(
              'div',
              { className: delimiterCls },
              '-'
            ),
            _react2.default.createElement(
              'div',
              { className: pickerWrapperCls + ' end-date-picker-wrapper' },
              _react2.default.createElement(_DatePicker2.default, { ref: 'eDate', format: format,
                size: size,
                mode: mode, emptyLabel: emptyLabel,
                clearIcon: clearIcon,
                value: eValue,
                required: !value[2] && required,
                validation: eValidation,
                disabled: !!value[2] || disabled,
                placeholder: ePlaceholder,
                getPopupContainer: getPopupContainer,
                onChange: this._selectEndDate.bind(this),
                disabledDate: format.indexOf('%d') == -1 ? this._disabledEndMonth.bind(this) : this._disabledEndDate.bind(this) })
            )
          ),
          showUpToNow && _react2.default.createElement(
            _checkbox.Checkbox,
            { className: upToNowCls,
              checked: value[2],
              disabled: disabled,
              onChange: this._toggleUpToNow.bind(this) },
            '至今'
          ),
          !!explain && _react2.default.createElement(
            'div',
            { className: 'has-explain ' + explainCls },
            explain
          )
        );
      }
    }
  }, {
    key: '_toggleUpToNow',
    value: function _toggleUpToNow(e) {
      var _this2 = this;

      var value = this.state.value;

      var v = e.target.checked;
      if (v) {
        value[1] = undefined;
      }
      value[2] = v;
      this.setState({ value: value }, function () {
        _this2._isValid(_this2._changeHandler.bind(_this2));
      });
    }
  }, {
    key: '_selectStartDate',
    value: function _selectStartDate(v) {
      var _this3 = this;

      var format = this.props.format;
      var value = this.state.value;


      var newV = v;
      //处理年月的情况
      if (v && format.indexOf('%d') == -1) {
        var date = new Date(v);
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
        newV = date.getTime();
      }

      value[0] = newV;
      this.setState({ value: value }, function () {
        _this3._isValid(_this3._changeHandler.bind(_this3));
      });
    }
  }, {
    key: '_selectEndDate',
    value: function _selectEndDate(v) {
      var _this4 = this;

      var format = this.props.format;
      var value = this.state.value;


      if (v) {
        var date = new Date(v);
        //处理年月的情况
        if (format.indexOf('%H') == -1) {
          if (format.indexOf('%d') == -1) {
            //FIXME 处理为下月1日，再向前拨一秒
            date.setMonth(date.getMonth() + 1, 1);
            date.setHours(0, 0, 0, 0);
            date.setSeconds(date.getSeconds() - 1);
          } else {
            //FIXME 处理为翌日0点，再向前拨一秒
            date.setDate(date.getDate() + 1);
            date.setHours(0, 0, 0, 0);
            date.setSeconds(date.getSeconds() - 1);
          }
        }
        value[1] = date.getTime();
      } else {
        value[1] = v;
      }

      this.setState({ value: value }, function () {
        _this4._isValid(_this4._changeHandler.bind(_this4));
      });
    }
  }, {
    key: '_disabledStartDate',
    value: function _disabledStartDate(v) {
      var _props2 = this.props;
      var disabledTime = _props2.disabledTime;
      var format = _props2.format;
      var value = this.state.value;


      var isDisabled = false;
      //如果计算日期比结束日期更大则禁用
      if (value[1]) {
        var eDate = new Date(value[1]);

        //消除不显示的时间后缀的影响
        if (format.endsWith('%S')) {
          eDate.setMilliseconds(0);
        } else if (format.endsWith('%M')) {
          eDate.setSeconds(0, 0);
        } else if (format.endsWith('%H')) {
          eDate.setMinutes(0, 0, 0);
        } else if (format.endsWith('%d')) {
          eDate.setHours(0, 0, 0, 0);
        }

        isDisabled = v > eDate.getTime();
      }

      return !!disabledTime && disabledTime([v, value[1], value[2]], 'start') || isDisabled;
    }
  }, {
    key: '_disabledEndDate',
    value: function _disabledEndDate(v) {
      var _props3 = this.props;
      var disabledTime = _props3.disabledTime;
      var format = _props3.format;
      var value = this.state.value;


      var isDisabled = false;
      //如果计算日期比开始日期更小则禁用
      if (value[0]) {
        var sDate = new Date(value[0]);

        //消除不显示的时间后缀的影响
        if (format.endsWith('%S')) {
          sDate.setMilliseconds(0);
        } else if (format.endsWith('%M')) {
          sDate.setSeconds(0, 0);
        } else if (format.endsWith('%H')) {
          sDate.setMinutes(0, 0, 0);
        } else if (format.endsWith('%d')) {
          sDate.setHours(0, 0, 0, 0);
        }

        isDisabled = v < sDate.getTime();
      }

      return !!disabledTime && disabledTime([value[0], v, value[2]], 'end') || isDisabled;
    }
  }, {
    key: '_disabledStartMonth',
    value: function _disabledStartMonth(v) {
      var disabledTime = this.props.disabledTime;
      var value = this.state.value;


      var isDisabled = false;
      if (value[1]) {
        var eDate = new Date(value[1]);
        var eYear = eDate.getFullYear(),
            eMonth = eDate.getMonth();
        var sDate = new Date(v);
        var sYear = sDate.getFullYear(),
            sMonth = sDate.getMonth();
        isDisabled = sYear > eYear || sYear == eYear && sMonth > eMonth || isDisabled;
      }

      return !!disabledTime && disabledTime([v, value[1], value[2]], 'start') || isDisabled;
    }
  }, {
    key: '_disabledEndMonth',
    value: function _disabledEndMonth(v) {
      var disabledTime = this.props.disabledTime;
      var value = this.state.value;


      var isDisabled = false;
      if (value[0]) {
        var date = new Date(value[0]);
        var sYear = date.getFullYear(),
            sMonth = date.getMonth();
        var eDate = new Date(v);
        var eYear = eDate.getFullYear(),
            eMonth = eDate.getMonth();
        isDisabled = eYear < sYear || eYear == sYear && eMonth < sMonth || isDisabled;
      }

      return !!disabledTime && disabledTime([value[0], v, value[2]], 'end') || isDisabled;
    }
  }, {
    key: '_changeHandler',
    value: function _changeHandler() {
      var _props4 = this.props;
      var onChange = _props4.onChange;
      var showUpToNow = _props4.showUpToNow;
      var value = this.state.value;
      //根据是否显示至今，决定传入外部onChange事件的参数

      var filterValue = showUpToNow ? value : value.slice(0, 2);
      //FIXME 是否应该对值做处理，空值就传空数组
      onChange(filterValue);
    }
  }, {
    key: '_isValid',
    value: function _isValid(callback) {
      var _refs = this.refs;
      var sDate = _refs.sDate;
      var eDate = _refs.eDate;


      var valid = true,
          explain = '';

      //确定DatePicker是否通过校验
      var isSDateValid = sDate.validate();
      valid = valid && isSDateValid;
      var isEDateValid = eDate.validate();
      valid = valid && isEDateValid;

      //通过了DatePicker自身的校验后，再校验整体。
      //FIXME 整体校验时，点击开始/结束时间并不会清除校验状态，如果需要和其他组件保持一致的话需要想办法处理
      if (valid) {
        var validator = this.props.validator;
        var value = this.state.value;

        if ((0, _lodashCompat.isFunction)(validator)) {
          var _result2 = validator(value);
          if (_result2 === false || (0, _lodashCompat.isString)(_result2) && _result2.length > 0) {
            valid = false;
            explain = _result2 || '';
          }
        }
      }
      this.setState({ valid: valid, explain: explain }, callback);

      return valid;
    }

    /**
     * 调用本组件的校验
     * @returns {*}
     */

  }, {
    key: 'validate',
    value: function validate() {
      return this._isValid();
    }

    /**
     * 清空异常状态  校验提示等
     */

  }, {
    key: 'clear',
    value: function clear() {
      var _refs2 = this.refs;
      var sDate = _refs2.sDate;
      var eDate = _refs2.eDate;

      sDate.clear();
      eDate.clear();
      this.setState({ valid: true, explain: '' });
    }
    /**
     * 重置控件，清空数据并清空校验状态
     */

  }, {
    key: 'reset',
    value: function reset() {
      var _this5 = this;

      if (this.props.mode !== "view") {
        (function () {
          var resetValue = _this5._formatValue(_this5.props.defaultValue) || _this5._getDefaultValue(_this5.props);
          _this5.setState({ value: resetValue, valid: true, explain: "" }, function () {
            _this5.props.onChange(resetValue);
          });
        })();
      }
    }

    /**
     * 默认值，如果有显示至今
     * @returns {*}
     * @private
     */

  }, {
    key: '_getDefaultValue',
    value: function _getDefaultValue(props) {
      if (props.showUpToNow) {
        return [undefined, undefined, false];
      } else {
        return [undefined, undefined];
      }
    }

    /**
     * 数组复制
     * @param v
     * @returns {*}
     * @private
     */

  }, {
    key: '_formatValue',
    value: function _formatValue(v) {
      return (0, _lodashCompat.isArray)(v) ? v.slice().map(function (item) {
        return parseInt(item);
      }) : v;
    }
  }]);

  return RangePicker;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
  placeholder: _propTypes2.default.arrayOf(_propTypes2.default.string),
  format: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  showUpToNow: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  prefixCls: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['default', 'small']),
  getPopupContainer: _propTypes2.default.func,
  validator: _propTypes2.default.func,
  validation: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
  disabledTime: _propTypes2.default.func,
  mode: _propTypes2.default.oneOf(['default', 'view']),
  emptyLabel: _propTypes2.default.string,
  clearIcon: _propTypes2.default.bool
}, _class.defaultProps = {
  placeholder: ['', ''],
  validation: ['', ''],
  format: '%Y-%m-%d',
  required: false,
  disabled: false,
  showUpToNow: false,
  onChange: _lodashCompat.noop,
  prefixCls: 'mt',
  size: 'default',
  getPopupContainer: null,
  mode: 'default',
  emptyLabel: '',
  clearIcon: true
}, _temp);
exports.default = RangePicker;